export function formatKina(v, { forceZero = true } = {}) {
    const n = Number(v || 0);
    if (!Number.isFinite(n)) return "K0.00";
    if (!forceZero && n === 0) return "—";
    return `K${n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
}

export function formatHours(v) {
    const n = Number(v || 0);
    if (!Number.isFinite(n)) return "0.00";
    return n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function short(v) {
    // For big KPI cards — K12,345 (no decimals)
    const n = Number(v || 0);
    return `K${n.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
}
